<template>
  <div>
    <el-button
      v-if="!order.order_lines || !order.order_lines.length"
      type="primary"
      size="small"
      @click="startVideoAt(0)"
    >
      {{ $t("main.orders.checkLoadVideo") }}
    </el-button>
    <el-dropdown
      v-else
      type="primary"
      split-button
      size="small"
      @click="startVideoAt(0)"
    >
      {{ $t("main.orders.checkLoadVideo") }}
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="order_line in order.order_lines"
          :key="order_line.name"
        >
          <span
            style="float: right; color: #222222; font-size: 13px"
            @click="startVideoAt(order_line.videoStart)"
            >{{ order_line.name }}
            {{ getRealTime(order_line.videoStart) | formatSeconds }} 🕑
            {{ getRealTime(order_line.finish_time) | formatSeconds }}</span
          >
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "ViewOrderButton",
  props: {
    order: Object,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    getRealTime: function (seconds) {
      const timestamp =
        new Date(this.order.start_date).detTime() + seconds * 1000;

      return new Date(timestamp);
      //return moment(this.order.start_date).add(seconds, "seconds");
    },
    startVideoAt(videoStart) {
      this.$emit("click", { order: this.order, videoStart });
    },
  },
};
</script>

<style scoped></style>
